import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useWorkspaceClientInvitationsStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    backgroundColor: projectIqTokens.bg,
    fontFamily: projectIqTokens.fontFamily,
    padding: designTokens.spacing[8],
  },
  pageContent: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[6],
    width: "100%",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: designTokens.spacing[3],
  },
  headerText: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  sectionTitle: {
    fontSize: designTokens.fontSize.base,
    fontWeight: "700",
    color: projectIqTokens.ink,
    margin: "0",
    fontFamily: projectIqTokens.fontFamily,
  },
  sectionDescription: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.muted,
    margin: "0",
  },
  retentionNote: {
    display: "flex",
    alignItems: "flex-start",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[3],
    borderRadius: designTokens.borderRadius.md,
    border: `1px solid ${projectIqTokens.tealLine}`,
    backgroundColor: projectIqTokens.tealSoft,
    color: projectIqTokens.tealInk,
    fontSize: designTokens.fontSize.sm,
    margin: "0",
  },
  retentionNoteIcon: {
    flexShrink: 0,
    marginTop: "2px",
  },
  adminListWrapper: {
    marginLeft: `-${designTokens.spacing[6]}`,
    marginRight: `-${designTokens.spacing[6]}`,
  },
  errorMessage: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.rust,
  },
  activityFlag: {
    display: "inline-flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    fontSize: designTokens.fontSize.sm,
    fontWeight: "600",
  },
  activityFlagActive: {
    color: projectIqTokens.green,
  },
  activityFlagPending: {
    color: projectIqTokens.amber,
  },
  activityFlagExpired: {
    color: projectIqTokens.muted,
  },
  activityFlagRevoked: {
    color: projectIqTokens.rust,
  },
  activityDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    flexShrink: 0,
    backgroundColor: "currentcolor",
  },
});
